<template>
  <div id="app">
    <options />
    <pending-tx-info />
    <wallet-connector />
    <sandbox-override v-if="$store.isSandbox"/>

    <navbar />
    <router-view/>
  </div>
</template>

<script>
import WalletConnector from "@/components/WalletConnector";
import Navbar from "@/components/Navbar";
import axios from "axios";
import PendingTxInfo from "@/components/PendingTransactionInfo";
import Options from "@/components/Options";
import SandboxOverride from "@/components/SandboxOverrides";

export default {
  components: {SandboxOverride, Options, PendingTxInfo, Navbar, WalletConnector},
  async mounted() {
    // Update the block height
    this.updateBlockHeight()

    this.$eventBus.$on('update-dao-info', this.updateDaoParams)

    // Go get gov parameters
    await this.updateDaoParamsLoop()
    this.$eventBus.$emit('dao-info-loaded')
  },
  methods:{
    async updateDaoParamsLoop(){
      await this.updateDaoParams()
      setInterval(this.updateDaoParams, 60 * 1000)
    },
    async updateDaoParams(){
      console.log("Updating DAO state")
      const daoContract = await this.$store.tezosToolkit.contract.at(this.$store.contracts.DAO)
      this.$store.daoParameters = await daoContract.storage()

      if (this.$store.daoParameters.timelockItem){
        try{
          const response = await axios.get(this.$store.daoParameters.timelockItem.proposal.descriptionLink)

          this.$store.timelockProposalDesc = this.$store.markdown(response.data)
          this.$store.timelockItemOutcome = await this.$store.daoParameters.outcomes.get(this.$store.daoParameters.timelockItem.id)
        } catch(e) {
          this.$store.timelockProposalDesc = e.toString()
        }
      }
    },
    async updateBlockHeight(){
      const currentBlock = await this.$store.tezosToolkit.rpc.getBlock()
      this.$store.currentBlockHeight = currentBlock.header.level
      setTimeout(this.updateBlockHeight, this.$store.blockTime / 2)
    },
  }
}
</script>

<style lang="scss">
  @import './assets/sass/globals';
  @import '~bulma/bulma';
  @import '~animate.css/animate.css';
  @import '~vue-popperjs/dist/vue-popper.css';
  @import '~@sweetalert2/theme-bulma/bulma.scss';
  @import url('https://fonts.googleapis.com/css2?family=Open+Sans:wght@300;400;700&display=fallback');

  // For our modal
  html.disable-scroll {
    overflow: hidden;
  }

  .popper{
    box-shadow: 0 0.5em 1em -0.125em rgba(10, 10, 10, 0.1), 0 0px 0 1px rgba(10, 10, 10, 0.02);
    text-align: left;
    padding: 1rem;
    text-transform: initial;
    .popper__arrow{
      border-color: transparent transparent #ebebeb transparent !important;
    }
  }
  .swal2-content{
    pre{
      margin-top: 1rem;
    }
  }
  .swal2-styled.swal2-confirm{
    background-color: #3EBD93;
  }

  .loader-wrapper{
    padding: 1rem;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .loader{
    border-right-color: transparent;
    border-top-color: transparent;
    &.left-spaced{
      margin-left: 0.5rem;
    }
    &.right-spaced{
      margin-right: 0.5rem;
    }
    &.is-large{
      width: 3rem;
      height: 3rem;
    }
    &.is-medium{
      width: 2rem;
      height: 2rem;
    }
    &.is-small{
      width: 1rem;
      height: 1rem;
    }
    &.is-primary{
      border: 2px solid #3EBD93;
      border-right-color: transparent;
      border-top-color: transparent;
    }
    &.is-white{
      border: 2px solid white;
      border-right-color: transparent;
      border-top-color: transparent;
    }
  }
</style>
